import { CalendarDay, PrayerHour } from "../calendar/utils";
import { LiturgyItem } from "./types";

export const getLetUsBlessTheLord = (
    day: CalendarDay,
    hour: PrayerHour
): LiturgyItem[] => {
    const sentenceId = day.sentenceId;

    if (
        sentenceId === "easter" ||
        sentenceId === "ascension" ||
        day.hymnId === "apostle-or-evangelist-easter" ||
        (day.collectId === "whitsun" && day.dayOfTheWeek === "sun")
    ) {
        return [
            {
                type: "chant",
                boldMode: "none",
                tone: "8.1",
                pointedText: {
                    clef: "c5",
                    verses: [
                        {
                            secondHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "Let",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "bless",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "the",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Lord.",
                                            notes: ["3"],
                                            long: true,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Al",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "le",
                                            notes: ["1"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "lu",
                                            notes: ["2", "3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "ia,",
                                            notes: ["3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Al ",
                                            notes: ["3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "  le  ",
                                            notes: ["2", "5", "4", "3", "2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: " lu ",
                                            notes: ["1", "2", "3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: " ia.",
                                            notes: ["3", "2"],
                                            long: true,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            },
            {
                type: "chant",
                boldMode: "all",
                tone: "8.1",
                pointedText: {
                    clef: "c5",
                    verses: [
                        {
                            secondHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "Thanks",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "be",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "to",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "God.",
                                            notes: ["3"],
                                            long: true,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Al",
                                            notes: ["2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "le",
                                            notes: ["1"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "lu",
                                            notes: ["2", "3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "ia,",
                                            notes: ["3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Al ",
                                            notes: ["3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: "  le  ",
                                            notes: ["2", "5", "4", "3", "2"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: " lu ",
                                            notes: ["1", "2", "3"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                        {
                                            text: " ia.",
                                            notes: ["3", "2"],
                                            long: true,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            },
        ];
    } else {
        return [
            {
                type: "chant",
                boldMode: "alternate",
                tone: "2.1",
                pointedText: {
                    clef: "f5",
                    verses: [
                        {
                            secondHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "Let",
                                            notes: ["6"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "us",
                                            notes: ["6"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "bless",
                                            notes: ["6"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "the",
                                            notes: ["6"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "Lord.",
                                            notes: ["6", "5", "4"],
                                            long: true,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            secondHalf: [
                                {
                                    syllables: [
                                        {
                                            text: "Thanks",
                                            notes: ["6"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "be",
                                            notes: ["6"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "to",
                                            notes: ["6"],
                                            long: false,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                                {
                                    syllables: [
                                        {
                                            text: "God.",
                                            notes: ["6", "5", "4"],
                                            long: true,
                                            dotBefore: false,
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            },
        ];
    }
};
